<template>
	<nav
		aria-label="Bouquet de services"
		class="service-menu__nav"
	>
		<div class="d-flex flex-column flex-sm-row">
			<div
				class="py-2 ap-blue lighten-3 service-menu__ps"
				:style="listsStyle"
			>
				<ServiceList
					:items="servicesPs"
					v-on="$listeners"
				/>
			</div>

			<div
				class="pa-3 ap-white service-menu__patient"
				:style="listsStyle"
			>
				<div>
					<ServiceList
						v-if="servicesPatient.length > 0"
						:items="servicesPatient"
						service-patient
					/>

					<AmeliproMessage
						v-if="!identifiedPatient && servicesPatient.length > 0"
						text
					>
						<p class="mb-0">
							{{ locales.messagePatient }}
						</p>
					</AmeliproMessage>
				</div>

				<div v-if="servicesPatient.length === 0">
					<AmeliproMessage text>
						<p class="mb-2">
							{{ locales.messageCPS }}
						</p>
					</AmeliproMessage>

					<AmeliproMessage text>
						<p class="mb-2">
							{{ locales.messageCPS2 }}
						</p>
					</AmeliproMessage>

					<AmeliproBtn
						id="service-menu-logout-btn"
						class="text-none"
						hover-underline
						text
						@click="$emit('log-out')"
					>
						{{ locales.logOutBtn }}
					</AmeliproBtn>
				</div>
			</div>
		</div>
	</nav>
</template>

<script setup lang="ts">
	import { PropType, computed } from 'vue';
	import AmeliproBtn from '../AmeliproBtn/AmeliproBtn.vue';
	import AmeliproMessage from '../AmeliproMessage/AmeliproMessage.vue';
	import BreakpointHelper from '../../helpers/BreakpointHelper';
	import { IndexedObject } from '../../types';
	import { Service } from '../ServiceBtn/types';
	import ServiceList from '../ServiceList';
	import { locales } from './locales';

	defineProps({
		identifiedPatient: {
			type: Boolean,
			default: false,
		},
		servicesPatient: {
			type: Array as PropType<Service[]>,
			default: () => [],
		},
		servicesPs: {
			type: Array as PropType<Service[]>,
			required: true,
		},
	});

	const breakpointHelper = new BreakpointHelper('smAndUp');

	const listsStyle = computed<IndexedObject>(() => {
		const listsStyleRules: IndexedObject = {
			flexBasis: '50%',
			maxWidth: '50%',
			width: '50%',
		};

		if (!breakpointHelper.isDesktop()) {
			listsStyleRules.width = '100%';
			listsStyleRules.maxWidth = '100%';
			listsStyleRules.flexBasis = '100%';
		}

		return listsStyleRules;
	});

	// TODO : Pour améliorer l'accessibilité du menu de service, il faut que le focus fasse une boucle de tabulation entre le premier et le dernier élément focusable
	// le code ci-dessous permettait de gérer le focus vers le premier élément lorsqu'un bouton de retour à l'accueil existait, ce qui n'est plus le cas aujourd'hui, il faut donc trouver une nouvelle manière de faire
	// const menuLastFocussableId = (): string => {
	// 	const element = document.querySelector('#service-menu')?.querySelectorAll('button, a');
	// 	const elementId = element?.item(element.length - 1).getAttribute('id');

	// 	return elementId !== null && elementId !== undefined ? elementId : '';
	// };

	// const setFocus = (id : string): void => {
	// 	let element;
	// 	element = document.querySelector('#service-menu-dialog-close-btn') as HTMLElement;
	// 	if (!breakpointHelper.isDesktop() && element !== null && element !== undefined) {
	// 		element.focus();
	// 	}
	// 	if (id !== null && id !== undefined && id !== '') {
	// 		element = document.getElementById(id) as HTMLElement;
	// 		element.focus();
	// 	}
	// };
</script>

<style lang="scss" scoped>
	.service-menu__home-btn {
		padding: 5px;
		background-color: $ap-blue-darken1;

		&:hover {
			background-color: $ap-blue-darken2;
		}
	}

	.service-menu-logo {
		min-width: 70px;
		max-width: 70px;
	}
</style>
